<app-loading-indicator></app-loading-indicator>
<app-toast-container></app-toast-container>

@if (isAuthenticated) {
  <app-header />
}

<div [ngClass]="{ container: isAuthenticated }">
  <router-outlet />
</div>

@if (isAuthenticated) {
  <app-footer />
}

@if (isAuthenticated) {
  <app-auto-logout-modal />
}
